import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=d12b4fee&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d12b4fee')) {
      api.createRecord('d12b4fee', component.options)
    } else {
      api.reload('d12b4fee', component.options)
    }
    module.hot.accept("./activity.vue?vue&type=template&id=d12b4fee&", function () {
      api.rerender('d12b4fee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/activity/activity.vue"
export default component.exports